export const BUTTON_TYPES = {
  INCREMENT: 'increment',
  DECREMENT: 'decrement',
};
